import React from "react";
import { Container, Row, Col } from "shards-react";
import ACVehicles from "../components/vehicles/ACVehicles";

const ACVehiclesTable = () => (
  <Container fluid className="main-content-container px-4">
    <Row>
      <Col className="p-2">
        <ACVehicles />
      </Col>
    </Row>
  </Container>
);

export default ACVehiclesTable;
